import { render, staticRenderFns } from "./PlanillasPendientes.vue?vue&type=template&id=d1bdf866&"
import script from "@/Servicios/PlanillasPendientes.js?vue&type=script&lang=js&"
export * from "@/Servicios/PlanillasPendientes.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports